import {
  Skeleton,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import BrandAvatar from "../../../Component/Avatar/Avatar"
import { InfoOutlined } from "@mui/icons-material";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { metricExplainations } from "../../../utils/constant";
import { extractDomain } from "../../../utils/helpers";
import DetailedTableModal from "../BrandAuditMetricDetails";
import { formatName } from "../../Dashboard/Component/CoreAttributes/CoreAttributes";
import { DiscoveryContext } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import Table, {
  StyledTableCell,
  StyledTableRow,
} from "./../../../Component/UI/Table/Table";
import useGeneratePreCategoryDimensions from "./../useGeneratePreCategoryDimensions";
import classes from "./CategoryDimensions.module.css";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/auth-context";
import { formatSourceData,formatOldSourceData } from "../../../utils/metric-sources"
import { useDispatch } from "react-redux";

const TABLE_HEADERS = [
  {
    id: "criteria",
    name: "Applicant Criteria",
  },
];

export default function CategoryDimensions({ category, entity }) {
  const [showModal, setShowModal] = useState(false);
  const discoveryCtx = useContext(DiscoveryContext);
  const { preDimensions } = useGeneratePreCategoryDimensions();

  const [isActionLoading, setIsActionLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();
  const customerId = user?.customer_id;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const primaryMarket = discoveryCtx.markets[0];
  const type = discoveryCtx.type;
  const showOldSourcesRecord = discoveryCtx.state.sourceValidationStatus === "PENDING";


  const saveActions = async (actionStatement, explanation, sources, brand) => {
    setIsActionLoading(true);
    const modifiedObj = {
      title: actionStatement,
      rationale: explanation,
      brand,
      persona: "General Persona",
      geography: primaryMarket == "General Market" ? "General Location" : primaryMarket,
      market: "General Market",
      category,
      llm: selectedLLM,
      isProduct: type === "product" ? true : false,
      sources,
    };

    const payload = {
      action_json: [modifiedObj],
      is_archived: 0,
      is_active: 1,
    };
    dispatch(createActionMetric(customerId, payload))
      .then(() => {
        dispatch(fetchActionMetrics(customerId));
        setIsActionLoading(false);
        toast.success("Action Added!", {
          autoClose: 700,
        });
      })
      .catch(() => {
        setIsActionLoading(false);
        toast.error("Something went wrong!", {
          autoClose: 700,
        });
      });
  }

  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "70%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  function renderHeaders(criterias) {
    const headers = [
      ...TABLE_HEADERS,
      ...discoveryCtx.competitors['default'].map((item) => ({
        id: item.name,
        name: item.name,
      })),
      ...discoveryCtx.competitors[category].map((item) => ({
        id: item.name,
        name: item.name,
      })),
    ];

    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            let ctxCompetitor = null;
            if (index !== 0) {
              if (index === 1) {
                ctxCompetitor = discoveryCtx.competitors['default'][0];
              } else {
                ctxCompetitor = discoveryCtx.competitors[category][index - 2];
              }
            }

            let domain = "";
            if (ctxCompetitor && ctxCompetitor?.domain) {
              domain = extractDomain(ctxCompetitor?.domain);
            }

            return (
              <TableCell key={index} className={index == 0 ? classes.table_head_cell_index : classes.table_head_cell}>
                <Tooltip title={header.name} placement="top">
                  <div className={classes.table_head_content}>
                    {index != 0 && (
                      // <img
                      //   data-html2canvas-ignore
                      //   className={classes.table_head_logo}
                      //   src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                      // />
                      <BrandAvatar
                      domainName={domain}
                      brandName={header.name}
                      />
                    )}
                    <div
                      className={
                        index === 0
                          ? classes.table_head_text_comp
                          : classes.table_head_text
                      }
                      style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                      {/* {header.name} */}
                      <div className={classes.table_head_title}>
                        <span style={{ width: '100%' }}>
                          {header.name}
                        </span>
                        {index === 0 && !showModal && (
                          <MUIIconButton onClick={() => setShowModal(true)} id="purches_criteria">
                            <InfoOutlined />
                          </MUIIconButton>
                        )}
                      </div>
                    </div>
                  </div>
                </Tooltip>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  function renderRows(rowItem, tableIndex) {
    return (
      <StyledTableRow key={tableIndex}>
        <StyledTableCell className={classes.attribute_headings}>
          {rowItem.name}
        </StyledTableCell>
        {rowItem.brands.map((item, index) => {
          let color = "#dc3545";
          let rating = "low";
          if (item.rating >= 7) {
            rating = "fair";
            color = "#2196F3";
          }
          if (item.rating >= 9) {
            color = "#198754";
            rating = "high";
          }

          const attributeSources = Array.isArray(item?.sources) &&  item?.sources?.length > 0 ? item?.sources : sourcesCategoryDim;
          const isEntityMatch =
            item?.name?.toLowerCase() === discoveryCtx.entity?.toLowerCase();

          const isSearchLLM = selectedLLM?.toLowerCase()?.includes("search");

          const isCustomTooltip =
            isEntityMatch && isSearchLLM && (showOldSourcesRecord || isValidated);

          const sources = isCustomTooltip
            ? (showOldSourcesRecord
              ? formatOldSourceData(attributeSources, selectedLLM)
              : formatSourceData(attributeSources, selectedLLM))
            : {};

          const TooltipComponent = isCustomTooltip ? MUIToolTip : Tooltip;

          const tooltipProps = isCustomTooltip
            ? {
              metric: "Applicant Criteria",
              attribute: rowItem.name,
              metricScore: Number(item.rating).toFixed(0),
              selectedInput: {
                llm: selectedLLM,
                market: "General Market",
                category,
                brand: item.name,
                product: item.name,
                persona: "General Persona",
                geography: primaryMarket == "General Market" ? "General Location" : primaryMarket
              },
              addToActionHandler: saveActions,
              actionText: "Add To Action",
              isActionLoading: isActionLoading,
              title: item.explanation,
              arrow: true,
              isBrandAudit: true,
              sources,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              }
            }
            : {
              title: item.explanation,
              arrow: true,
              slotProps: {
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -18],
                      },
                    },
                  ],
                },
              },
            };

          return (
            item.rating ? (
              <TooltipComponent {...tooltipProps}>
                <StyledTableCell
                  style={{ color }}
                  className={classes.attribute_score}
                >
                  {Number(item.rating).toFixed(0)}
                </StyledTableCell>
              </TooltipComponent>
            )
              : (
                <StyledTableCell
                  style={{ color }}
                  className={classes.attribute_score}
                >
                  -
                </StyledTableCell>
              )
          );
        })}
      </StyledTableRow>
    );
  }

  let loading = true;
  let criterias = {};
  let sourcesCategoryDim = [];
  let isValidated = false;
  let hasError = false;
  const transactionStatus = discoveryCtx.state.transactionStatus
  const categoryDimension = discoveryCtx?.category_dimensions?.[selectedLLM]?.[category]?.[primaryMarket]?.[selectedPersona]

  if (
    categoryDimension &&
    Object.keys(categoryDimension).length > 0
  ) {
    criterias = categoryDimension
    sourcesCategoryDim = categoryDimension?.sources
    isValidated = categoryDimension?.isValidated;
    loading = false;
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  } else {
    loading = false;
  }
  return (
    <MUICard variant="elevated" elevation={0} className={classes.card}>
      {!loading && !hasError && criterias?.data?.length > 0 && (
        <>
          <Table
            elevation={0}
            data={criterias?.data}
            renderHeaders={() => renderHeaders(criterias?.data)}
            render={renderRows}
          />
          <DetailedTableModal
            show={showModal}
            onClose={() => setShowModal(false)}
            headers={
              discoveryCtx.competitors?.['default']?.[0]
                ? [
                  discoveryCtx.competitors['default'][0].name,
                  ...discoveryCtx.competitors?.[category]?.map((item) => item.name) || [],
                ]
                : []
            } data={criterias?.data}
            renderHeaders={renderHeaders}
            formatName={formatName}
            classes={classes}
            pdfHeight={300}
            pdfTitle={`${entity}-Applicant Criteria`}
          />
        </>
      )}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={"Error Fetching Category Dimensions"}
            message={"Request Failed"}
          />
        </div>
      )}
      {loading && !hasError && <LoadingSkeletion />}
    </MUICard>
  );
}
